import svgPaths from "../imports/svg-3mv0mzx0sk";

interface RaksulLogoProps {
  variant?: 'default' | 'white';
}

function RaksulLogo({ variant = 'default' }: RaksulLogoProps) {
  // white バリアント時は全て白色に
  const blackColor = variant === 'white' ? 'white' : 'black';
  const blueColor = variant === 'white' ? 'white' : '#00A1ED';
  const magentaColor = variant === 'white' ? 'white' : '#E0007A';
  const yellowColor = variant === 'white' ? 'white' : '#FFEE00';

  return (
    <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 130 36">
      <g>
        <path d={svgPaths.pa683300} fill={blackColor} />
        <path d={svgPaths.p6d98100} fill={blueColor} />
        <path d={svgPaths.p2a214c00} fill={magentaColor} />
        <path d={svgPaths.p188000} fill={yellowColor} />
      </g>
    </svg>
  );
}

interface ServiceNameProps {
  variant?: 'default' | 'white';
}

function ServiceName({ variant = 'default' }: ServiceNameProps) {
  const textColor = variant === 'white' ? 'text-white' : 'text-[#101112]';

  return (
    <p
      className={`font-['Helvetica_Neue',sans-serif] leading-tight not-italic relative shrink-0 ${textColor} text-nowrap whitespace-pre`}
      style={{ fontSize: '18px', fontWeight: 700 }}
    >
      広告の窓口
    </p>
  );
}

interface NovasellLogoProps {
  variant?: 'default' | 'white';
}

// 新しいロゴ構造: [ラクスルロゴ] 広告の窓口
export function NovasellLogo({ variant = 'default' }: NovasellLogoProps) {
  return (
    <div className="flex items-center gap-3">
      <div className="h-[28px] w-[100px]">
        <RaksulLogo variant={variant} />
      </div>
      <ServiceName variant={variant} />
    </div>
  );
}
